// Obtener errores en response de backend
export const getResponseError = (errorObject, defaultError) => {
    if (!errorObject) {
        return defaultError || 'Error al realizar la acción';
    }
    if (errorObject.detail) {
        return errorObject.detail;
    }
    if (errorObject.message) {
        return errorObject.message;
    }
    if (errorObject.error) {
        return errorObject.error;
    }
    return defaultError || 'Error al realizar la acción';
}

// Validaciones en campos de formularios
export const requiredField = value => value ? undefined : 'Campo requerido.'
// export const maxLength = max => value =>
//     value && value.length > max ? `Debe tener como máximo ${max} caractéres` : undefined
// export const maxLength15 = maxLength(15)
// export const number = value => value && isNaN(Number(value)) ? 'Debe ser numérico' : undefined
// export const minValue = min => value =>
//     value && value < min ? `Debe ser almenos ${min}` : undefined
// export const minValue18 = minValue(18)


// validar que solo se ingresen números
// export const onlyNumbersField = value =>
//     value && !/^[0-9]+$/.test(value) ? 'Solo se permiten números.' : undefined


// export const numberField = value => value && isNaN(Number(value)) ? 'Debe ser numérico' : undefined

// validar que solo se ingresen letras y espacios
export const nameField = value =>
    value && !/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(value) ? 'Solo se permiten letras y espacios.' : undefined

// validar que solo se ingresen letras y números
export const usernameField = value =>
    value && !/^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ]+$/.test(value) ? 'Solo se permiten letras y números' : undefined

// validar que solo se ingresen letras, números y espacios
export const companyNameField = value =>
    value && !/^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ\s]+$/.test(value) ? 'Solo se permiten letras, números y espacios' : undefined

// validar número de teléfono
export const phoneField = value =>
    value && !/^[+\d\s-]+$/.test(value) ? 'Ingresar teléfono válido.' : undefined

// validar correo electrónico
export const emailField = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
        'Correo no válido' : undefined

// validar números positivos
export const positiveNumberField = value => value && isNaN(Number(value)) || Number(value) < 0 ? 'Debe ser número positivo' : undefined

// validar que no sea 0
export const notZeroField = value => value && Number(value) === 0 ? 'No puede ser 0' : undefined;

// validar que solo se ingresen números, letras y guiones
export const identificationNumberField = value =>
    value && !/^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ-]+$/.test(value) ? 'Ingresar identificación válida.' : undefined

// validar porcentajes positivos
export const positivePercentageField = value => value && isNaN(Number(value)) || Number(value) < 0 || Number(value) > 100 ? 'Porcentaje no válido' : undefined


